import { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../../api/apiClient';
import { DEFAULT_HIDDEN_FIELDS } from './reservationFormConfig';

// 예약 입력칸 숨김 설정. 회사는 묻지 않는다 — 서버가 보는 사람으로 정한다(운영자=사이트 주인 회사 / 테넌트=자기 회사).
//   예전엔 'PINE' 을 들고 물었다(서버는 무시했지만 하드코딩이라 뺐다, 2026-10-27).
export function useReservationFieldSettings() {
  const [hiddenFields, setHiddenFields] = useState([...DEFAULT_HIDDEN_FIELDS]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    apiClient.get('/api/admin/reservations/field-settings')
      .then((res) => {
        if (!alive) return;
        if (res.ok && res.data?.success && Array.isArray(res.data.data?.hidden_fields)) {
          setHiddenFields(res.data.data.hidden_fields);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => { alive = false; };
  }, []);

  const hiddenSet = useMemo(() => new Set(hiddenFields), [hiddenFields]);

  return { hiddenFields, hiddenSet, loading, setHiddenFields };
}
